import { Component, h, Host, State } from '@stencil/core';
import { Release, ReleaseByYear, ReleasesByYear } from '~model/press';
import { get } from '~service/ajax-service';
import { translate } from '~service/translation-service';

@Component({
  tag: 'uvex-press-list',
  styleUrl: './press-list.scss',
})
export class PressList {
  @State() releasesByYear: ReleasesByYear;

  async componentWillLoad() {
    const releases = (await get('/current-releases')) as Release[];

    this.releasesByYear = releases.reduce((releasesByYear: ReleasesByYear, release: Release) => {
      const { year } = release;
      if (!releasesByYear.hasOwnProperty(year)) {
        releasesByYear[year] = {
          year: year,
          active: false,
          releases: [],
        };
      }
      releasesByYear[year].releases.push(release);
      return releasesByYear;
    }, {});

    const currentYear = new Date().getFullYear();
    if (this.releasesByYear.hasOwnProperty(currentYear)) {
      this.releasesByYear[currentYear].active = true;
    }
  }

  setYearActiveClick(event: MouseEvent, releaseByYear: ReleaseByYear) {
    event.preventDefault();
    releaseByYear.active = true;
    this.releasesByYear = { ...this.releasesByYear, ...{ [releaseByYear.year]: releaseByYear } };
  }

  renderYear(releaseByYear: ReleaseByYear) {
    if (!releaseByYear.active) {
      return (
        <div>
          <a class="btn btn-link btn-lg icon-left" onClick={e => this.setYearActiveClick(e, releaseByYear)}>
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" width="30" height="30">
              <path d="M416 208H272V64c0-17.67-14.33-32-32-32h-32c-17.67 0-32 14.33-32 32v144H32c-17.67 0-32 14.33-32 32v32c0 17.67 14.33 32 32 32h144v144c0 17.67 14.33 32 32 32h32c17.67 0 32-14.33 32-32V304h144c17.67 0 32-14.33 32-32v-32c0-17.67-14.33-32-32-32z" />
            </svg>
            <span>{translate('press.loadMore', releaseByYear.year)}</span>
          </a>
        </div>
      );
    }

    return (
      <div>
        <div class="panel">
          <div class="panel-heading">
            <h4 class="panel-title">
              <strong>{releaseByYear.year}</strong>
            </h4>
          </div>
        </div>
        {releaseByYear.releases.map(release => this.renderRelease(release))}
      </div>
    );
  }

  renderRelease(release: Release) {
    return (
      <article>
        <h2>{release.title}</h2>
        <div class="block media">
          <div class="media-left">
            <img src={release.image} class="img-fluid" />
          </div>
          <div class="media-body">
            <p>
              <strong>{release.formattedDate}</strong>
              <br />
              {release.teaser}
              <br />
              <a href={release.link.self}>{translate('more')}</a>
            </p>
          </div>
        </div>
      </article>
    );
  }

  render() {
    const years = Object.keys(this.releasesByYear).sort().reverse();
    return <Host>{years.map(year => this.renderYear(this.releasesByYear[year]))}</Host>;
  }
}
